import React, { Component } from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import { fromJS } from "immutable";
import InvalidFeedback from "../../../common/invalid_feedback";
import Api from "../../api";

class AutocompleteCompany extends Component {
  fetchCompanies = this.debounce(value => {
    Api.showCompanies(value).then(response => {
      response.push({id: null, name: value, logo_image: ""});
      this.setState({companies: response});
    });
  }, 300);

  constructor(props) {
    super(props);

    this.state = {
      companies: []
    };

    this.initialCompany = fromJS(props.company);
  }

  handleCompanyName = (event) => {
    const value = event.target.value;
    if (!value) {
      return;
    }
    this.fetchCompanies(value);
  }

  handleClick = (item) => {
    const { company, setCompany, updateShown } = this.props;

    company.id = item.id;
    company.name = item.name;

    setCompany(company);
    updateShown(!item.id);
  }

  handleClearButtonClick = () => {
    const { setCompany, updateShown } = this.props;
    setCompany(this.initialCompany.toJS());
    updateShown(false);
  }

  debounce(fn, time) {
    let timeoutId;
    return wrapper;

    function wrapper(...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        timeoutId = null;
        fn(...args);
      }, time);
    }
  }

  render () {
    const { companies } = this.state;
    const { company, defaultCompanyImage, disabled } = this.props;

    return (
      <Downshift
        onChange={selection => {
          if (selection === null) {
            this.handleClearButtonClick();
          } else {
            this.handleClick(selection);
          }
        }}

        itemToString={item => (item ? item.name : "")}
        defaultInputValue={company.name}
      >
        {({
          selectedItem,
          getInputProps,
          getItemProps,
          highlightedIndex,
          clearSelection,
          isOpen,
        }) => {
          return (
            <div>
              <div className='input-group mb-1'>
                <input
                  {...getInputProps({
                    onChange: event => {
                      this.handleCompanyName(event);
                    },
                    placeholder: "サイバーエージェント ※「株式会社」などは省略",
                    disabled: disabled
                  })}
                  id='company_name'
                  className={`${company.errors.name ? "form-control is-invalid" : "form-control"}`}
                  required='required'
                  type='text'
                  name='name'
                />

                {selectedItem && (
                  <div className='input-group-append'>
                    <button
                      type='button'
                      className='input-group-text'
                      onClick={() => {
                        this.handleClearButtonClick();
                        clearSelection();
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}

                <InvalidFeedback errors={company.errors.name} label='会社名' />
              </div>

              {isOpen && (
                <ul className='company-search list-group company-list'>
                  {companies.map((item, index) => (
                    <li
                      key={item.id}
                      {...getItemProps({
                        item,
                        style: {
                          backgroundColor: highlightedIndex === index ? "#eee5fb" : "white",
                          fontWeight: selectedItem === item ? "bold" : "normal",
                        },
                        onClick: () => {
                          this.handleClick(item);
                        }
                      })}
                      className='list-group-item'
                    >
                      <span>
                        <img
                          height='60'
                          width='60'
                          className='img-thumbnail mr-3'
                          src={item.logo_image ? item.logo_image : defaultCompanyImage}
                          alt={item.name}
                        />
                      </span>
                      {item.id ? item.name : item.name + "を追加"}
                    </li>
                  ))}
                </ul>
              )}

              {selectedItem && !selectedItem.id && (
                <div className='input-group-append'>
                  <p className='caption m-0'>
                    ※この会社のページを新規作成します。重複登録にご注意ください。
                  </p>
                </div>
              )}
            </div>
          );
        }}
      </Downshift>
    );
  }
}

AutocompleteCompany.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
  }).isRequired,
  setCompany: PropTypes.func.isRequired,
  updateShown: PropTypes.func.isRequired,
  defaultCompanyImage: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default AutocompleteCompany;
